/*
 * Copyright © 2023 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

import React, { ReactElement, ReactNode } from "react"
import { Size } from "@medaica/common/views/exam/virtual-exam/video-layout"

const VideoContainer = ({ size, children }: { size: Size; children: ReactNode }): ReactElement => {
  return (
    <div className="panel flex flex-shrink-0 relative bg-gray-200" style={{ width: size.width, height: size.height }}>
      {children}
    </div>
  )
}

export default VideoContainer
